<template>
  <div class="">
    <div class="cash-wrap">
      <div class="cash-item">
        <div class="cash-name">账户余额</div>
        <div class="cash-value">¥{{ account.cash }}</div>
      </div>
    </div>
    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="openDialog">发放</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
    <template #type="{row}">
        <div>
            {{row.pm ? '充值' : '扣除'}}
        </div>
    </template>
    </auto-table>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <el-form :inline="true">
        <el-form-item label="金额">
          <el-input v-model="cashInfo.cash"></el-input>
        </el-form-item>
       
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendCash"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      DataList: [],
      Option: [
        { name: "说明", value: "name" },
        { name: "金额(元)", value: "cash" },
        { name: "类型", value: "type", type: "custom" },
        { name: "时间", value: "create_time" },
      ],
      Total: 0,
      type: "",
      id: "",
      dialogVisible: false,
      load: false,
      account:{},
      cashInfo: {
        cash: 0,
      },
    };
  },

  mounted() {
    this.id = this.$route.query.id;
  },

  methods: {
    sendCash(){
        this.$axios({
          url: "/shared/clubPromtAccount/addCash",
          method: "post",
          data: {
            club_id: this.id,
            cash: this.cashInfo.cash,
            name: '系统发放',
            type: 3
          },
        }).then((res) => {
          this.$message.success("发放成功");
          this.dialogVisible = false;
          this.getList(1);
          this.getCoachCash();
        })
    },
    openDialog() {
      this.dialogVisible = true;
    },
    init() {
      if (!this.load) {
        this.load = true;
        this.getList(1);
        this.getCoachCash();
      }
    },
    userDetail(row) {
      this.$router.push({ name: "userDetails", params: { id: row.user_id } });
    },
    getCoachCash() {
      this.$axios({
        url: "/shared/clubPromtAccount/club",
        params: {
          id: this.id,
        },
      }).then((res) => {
        this.account = res.data.data;
      });
    },
    //分成记录
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/shared/clubPromtRecord/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          club_id: this.id,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.cash-wrap {
  display: flex;
  margin-bottom: 10px;
}
.cash-item {
  padding: 10px 20px;
  margin-right: 20px;
  background-color: rgba(243, 202, 140, 0.7);
  border-radius: 10px;
  min-width: 100px;
}
.cash-name {
  font-size: 14px;
}
.cash-value {
  font-size: 20px;
  margin-top: 10px;
}
</style>